import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

import TerminalController from "./terminal_controller"
application.register("terminal", TerminalController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import ImgLoadController from "./img_load_controller"
application.register("img-load", ImgLoadController)
